<p-table [value]="whatsAppBusinessAccounts" [columns]="cols" [rowHover]="true"
         dataKey="id" [paginator]="true"
         [rows]="10" [showCurrentPageReport]="true"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
         [rowsPerPageOptions]="[10, 25, 50]">
    <ng-template pTemplate="caption">
        <div class="table-header p-d-flex">
            <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
            <h5 class="p-ml-3 p-mt-1">WhatsApp Setup</h5>
        </div>
        <div class="table-header p-d-flex p-jc-between">
            <h5 class="p-ml-3 p-mt-1">Active Numbers</h5>
            <div class="p-d-fle">
                <p-button label="Connect with Facebook" icon="pi pi-facebook" (click)="connectWithFacebook()"
                          class="facebookBtn"></p-button>
                <p-button label="Sync numbers" icon="pi pi-cloud-download" class="p-ml-2" (click)="syncBusinessAccount()"></p-button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" class="text-sm">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <ng-container *ngFor="let col of columns">
                <td [class.action]="col.field == 'isDefault'">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'registered'">
                            <!-- Phone already register -->
                            <p-radioButton
                                *ngIf="rowData.registered"
                                [value]="true"
                                [(ngModel)]="rowData.registered"
                                (onClick)="deregisterPhone(rowData)">
                            </p-radioButton>
                            <!-- Phone not register yet -->
                            <p-radioButton
                                *ngIf="!rowData.registered"
                                [value]="true"
                                [(ngModel)]="rowData.registered"
                                (onClick)="registerPhone(rowData)">
                            </p-radioButton>

                            {{ rowData[col.field] ? 'Yes' : 'No' }}

                        </ng-container>
                        <ng-container *ngSwitchCase="'isActive'">
                            <p-radioButton
                                *ngIf="rowData.isActive"
                                [value]="true"
                                [(ngModel)]="rowData.isActive"
                                (onClick)="makeActiveInactive(rowData.id, false)">
                            </p-radioButton>
                            <p-radioButton
                                *ngIf="!rowData.isActive"
                                [value]="true"
                                [(ngModel)]="rowData.isActive"
                                (onClick)="makeActiveInactive(rowData.id, true)">
                            </p-radioButton>
                            {{ rowData[col.field] ? 'Yes' : 'No' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'isDefault'">
                            <p-radioButton
                                [disabled]="!rowData.isActive" [value]="true"
                                [(ngModel)]="rowData.isDefault"
                                (onClick)="makeDefault(rowData)">
                            </p-radioButton>
                            {{rowData.isDefault ? 'Yes' : 'No'}}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{rowData[col.field]}}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
</p-table>

<!-- Register WatsApp Phone into Facebook Cloud API -->
<ng-container *ngIf="displayWhatsAppPhoneRegister">
    <p-dialog header="Register Phone" [(visible)]="displayWhatsAppPhoneRegister" [modal]="false" [responsive]="true"
              (visibleChange)="cancelPhoneRegister()" [style]="{width: '30vw'}">
        <form [formGroup]="registerFrom">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Enter your WhatsApp two-step verification PIN</label>
                    <input formControlName="pin" onlyNumber type="text" class="inputStyle p-inputtext w-100"
                           pInputText placeholder="******" />

                    <div class="p-d-flex p-flex-column p-mt-3">
                        <a class="p-mb-2" href="https://faq.whatsapp.com/1920866721452534/?helpref=uf_share" target="_blank">
                            How to manage two-step verification settings
                        </a>
                        <a href="https://faq.whatsapp.com/2183055648554771/?helpref=uf_share" target='_blank'>
                            How to reset your two-step verification PIN
                        </a>
                    </div>
                </div>
            </div>
        </div>
        </form>
        <p-footer>
            <button type="button" pButton (click)="cancelPhoneRegister()"
                    label="Cancel" class="p-button-secondary"></button>
            <button type="button" pButton label="Confirm" [disabled]="registerFrom.invalid"
                    (click)="registerWhatsAppBusinessPhone()"></button>
        </p-footer>

    </p-dialog>
</ng-container>

